module.exports = __webpack_public_path__ + "static/media/ias-logo.bb7c0eb4.png";